import { useEffect, useState } from "react";
import { getConvenios, getTasasByConvenio } from "../services/apiService";

/**
 * Hook que obtiene la tasa asociada al primer convenio activo de la empresa seleccionada.
 * Devuelve además información del convenio (tipoConvenio y diasLibranza) para los cálculos posteriores.
 */
const useTasa = ({ empresa, plazo, configuration }) => {
    const [tasa, setTasa] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!empresa || !plazo || !configuration) {
            setTasa(null);
            setError(null);
            return;
        }

        const fetchTasa = async () => {
            setLoading(true);
            setError(null);
            
            try {
                const convenios = await getConvenios(configuration, empresa);

                if (!convenios.length) {
                    setTasa(null);
                    setError('La empresa seleccionada no tiene convenios activos');
                    return;
                }

                const convenioSeleccionado = convenios[0];

                const listaTasas = await getTasasByConvenio(configuration, convenioSeleccionado.id, plazo);

                const tasaSeleccionada = listaTasas[0];

                if (tasaSeleccionada) {
                    const tasaConConvenio = {
                        ...tasaSeleccionada,
                        tipoConvenio: convenioSeleccionado.tipoConvenio,
                        diasLibranza: convenioSeleccionado.diasLibranza
                    };
                    setTasa(tasaConConvenio);
                } else {
                    setTasa(null);
                    setError('No se encontró tasa para esta combinación');
                }
            } catch (error) {
                setTasa(null);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTasa();
    }, [empresa, plazo, configuration]);

    return { tasa, loading, error };
};

export default useTasa;